<template>
  <v-container>
    <v-btn class="ml-8" color="secondary" to="/admin/keuangan/list">
      <v-icon left> mdi-arrow-left </v-icon>
      Kembali
    </v-btn>
    <form class="pa-4" v-on:keyup.enter="submit">
      <v-card flat outlined class="ma-4">
        <v-toolbar flat color="primary white--text">
          <v-toolbar-title>Data Keuangan</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col>
              <v-menu :close-on-content-click="true" max-width="290">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="!date ? '' : formatDate(date + '-01')"
                    outlined
                    clearable
                    label="Bulan Laporan"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="date = null"
                    :error-messages="dateError"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model.trim="$v.date.$model"
                  no-title
                  type="month"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-file-input
                label="File Laporan Data Keuangan"
                v-model="file"
              ></v-file-input>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-0">
            <v-col class="mr-3">
              <v-text-field
                prefix="Rp"
                outlined
                label="Pemasukan bulan ini"
                type="text"
                :error-messages="incomeError"
                :value="pemasukan | currencyNum"
                @input="value => pemasukan = value"
                oninput="this.value=this.value.replace(/[^0-9]/g,'');"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                prefix="Rp"
                outlined
                label="Pengeluaran bulan ini"
                type="text"
                :error-messages="outcomeError"
                :value="pengeluaran | currencyNum"
                @input="value => pengeluaran = value"
                oninput="this.value=this.value.replace(/[^0-9]/g,'');"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-0">
            <v-col>
              <v-text-field
                prefix="Rp"
                readonly
                outlined
                label="Saldo akhir bulan ini"
                type="text"
                v-model="saldo"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-btn color="primary" @click="submit">Submit</v-btn>
        </v-card-text>
      </v-card>
    </form>
    <p v-if="isSubmitError" class="mt-2 red--text text-caption error-caption">
      Maaf, terjadi kesalahan saat submit data, mohon ulangi submit kembali. ^^
    </p>

    <p v-if="isFormError" class="mt-2 red--text text-caption error-caption">
      "Manusia memang sering melakukan kesalahan, tapi yang terpenting adalah
      bagaimana kita memperbaikinya" <br />
      -Admin
    </p>
  </v-container>
</template>

<script>
import router from "../../router";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      isSubmitError: false,
      isFormError: false,
      date: "",
      pemasukan: "",
      pengeluaran: "",
      saldo: "",
      file: null,
      details: {},
    };
  },
  filters: {
    currencyNum(value) {
      if(!value) return ""
      return value.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  validations: {
    date: {
      required,
    },
    pemasukan: {
      required,
    },
    pengeluaran: {
      required,
    },
  },
  computed: {
    total() {
      //MENGHILANGKAN TITIK DALAM ANGKA
      let income = this.pemasukan.replace(/[.]/g, "");
      let outcome = this.pengeluaran.replace(/[.]/g, "");
      let total = Number(income) - Number(outcome);
      return total;
    },
    dateError() {
      const errors = [];
      if (!this.$v.date.$dirty) return errors;
      !this.$v.date.required && errors.push("Bulan laporan tidak boleh kosong");
      return errors;
    },
    incomeError() {
      const errors = [];
      if (!this.$v.pemasukan.$dirty) return errors;
      !this.$v.pemasukan.required &&
        errors.push("Pemasukan tidak boleh kosong");
      return errors;
    },
    outcomeError() {
      const errors = [];
      if (!this.$v.pengeluaran.$dirty) return errors;
      !this.$v.pengeluaran.required &&
        errors.push("Pengeluaran tidak boleh kosong");
      return errors;
    },
    keuanganDetails() {
      return this.details;
    },
  },
  watch: {
    total() {
      this.saldo = this.total.toLocaleString("id-ID");
    },
    keuanganDetails() {
      this.pemasukan = this.keuanganDetails.income;
      this.pengeluaran = this.keuanganDetails.outcome;
      this.date = this.keuanganDetails.date;
    },
  },
  methods: {
    formatDate(targetDate) {
      return this.$moment(targetDate).format("MMMM YYYY");
    },
    async submit() {
      let masjidUid = localStorage.getItem("masjid");
      let newDate = this.date + "-01";

      this.$v.$touch()
      if (
        this.$v.date.$invalid ||
        this.$v.pemasukan.$invalid ||
        this.$v.pengeluaran.$invalid
      ) {
        this.isFormError = true;
      } else {
        if (this.$route.params.isEdit) {
          //UPDATE PEMASUKAN
          await this.axios
            .post(`/keuangan/update/${this.details.inUid}`, {
              masjid_uid: masjidUid,
              transaction: "in",
              value: this.pemasukan,
              description: "",
              date: newDate,
            })
            .then((res) => {
              console.log(res, "res update pemasukan");
              //UPDATE PENGELUARAN
              return this.axios.post(
                `/keuangan/update/${this.details.outUid}`,
                {
                  masjid_uid: masjidUid,
                  transaction: "out",
                  value: this.pengeluaran,
                  description: "",
                  date: newDate,
                }
              );
            })
            .then((res) => {
              console.log(res, "res update pengeluaran");
            })
            .catch((err) => {
              console.log(err, "err update keuangan");
              this.isSubmitError = true;
            });
        } else {
          // POST PEMASUKAN
          await this.axios
            .post("/keuangan", {
              masjid_uid: masjidUid,
              transaction: "in",
              value: this.pemasukan,
              description: "",
              date: newDate,
            })
            .then((response) => {
              console.log(response, "res post pemasukan");
            })
            .catch((error) => {
              console.log(error, "error post pemasukan");
              this.isSubmitError = true;
            });

          //POST PENGELUARAN
          await this.axios
            .post("/keuangan", {
              masjid_uid: masjidUid,
              transaction: "out",
              value: this.pengeluaran,
              description: "",
              date: newDate,
            })
            .then((response) => {
              console.log(response, "res post pengeluaran");
            })
            .catch((error) => {
              console.log(error, "error post pengeluaran");
              this.isSubmitError = true;
            });
        }

        //POST FILE LAPORAN KEUANGAN
        if (this.file != null) {
          let formData = new FormData();
          formData.append("file", this.file);

          await this.axios
            .post(`/masjid/keuangan/file/${masjidUid}`, formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
              console.log(response, "res file laporan");
            })
            .catch((error) => {
              console.log(error, "error file laporan");
              this.isSubmitError = true;
            });
        }

        if (this.isSubmitError == false) router.push("/admin/keuangan/list");
      }
    },
  },
  mounted() {
    if (this.$route.params.isEdit) {
      this.details = this.$store.state.keuanganDetails;
      console.log(this.details, "masuk");
    }
  },
};
</script>

<style>
</style>